export const LAZY_LOADING_TYPE_BUTTON = 'LAZY_BUTTON';
export const LAZY_LOADING_TYPE_SCROLL = 'LAZY_SCROLL';
